import { Flex, ModuleLayout, Space, Spacing } from '@billy/design-system'
import Cookies from 'js-cookie'
import { ReactElement } from 'react'
import { useParams } from 'react-router'

import { CookieKeys } from '../../../../enums/cookieKeys'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { RecurringInvoiceContextProvider } from './contexts/recurringInvoiceContext'
import { RecurringInvoicePreview } from './elements/RecurringInvoicePreview'
import { RecurringInvoiceTitle } from './elements/RecurringInvoiceTitle'
import { RecurringInvoiceViewActions } from './elements/RecurringInvoiceViewActions'
import { RecurringInvoiceViewSidebar } from './elements/RecurringInvoiceViewSidebar'

// react-router-v5-compat's useParams<T>() constrains T to Record<string, string | undefined>,
// which a named interface does not satisfy because it has no implicit index signature.
type RecurringInvoiceViewUrlParams = {
  recurringInvoiceId: string
}

export const RecurringInvoiceView = (): ReactElement | null => {
  const { recurringInvoiceId } = useParams<RecurringInvoiceViewUrlParams>()
  const { url: recurringInvoicesUrl } = useOrganizationViewUrl(reactRoute.organization.recurringInvoices.getMainRoute())

  const storedRecurringInvoicesListQuery = Cookies.get(CookieKeys.InvoicingRecurringInvoicesListQuery) || ''

  if (!recurringInvoiceId) {
    return null
  }

  return (
    <RecurringInvoiceContextProvider recurringInvoiceId={recurringInvoiceId}>
      <ModuleLayout
        backButtonTo={recurringInvoicesUrl && `${recurringInvoicesUrl}${storedRecurringInvoicesListQuery}`}
        sideActions={<RecurringInvoiceViewActions />}
        title={<RecurringInvoiceTitle />}
        withBackButton
      >
        {/* Vertical Space is needed for the ribbon to "wrap" around
         the preview and not be cut off by the top of the container */}
        <Space size="s6" />
        <Flex justifyContent="center">
          <Flex flexDirection="column" gap={Spacing.S24} width="fit-content">
            <Flex gap={Spacing.S24} justifyContent="center" width="fit-content">
              <RecurringInvoicePreview />
              <RecurringInvoiceViewSidebar />
            </Flex>
          </Flex>
        </Flex>
      </ModuleLayout>
    </RecurringInvoiceContextProvider>
  )
}
